import { Adapter, SendToOptions } from './adapter';
import { getScript } from '../utils/http';

// TODO: test
export default class AdapterImpl implements Adapter {
  public async init(): Promise<void> {
    if (typeof window.customBrowserInterface === 'undefined') {
      await getScript('https://tiem-cdn.qq.com/slugteam/sdk/browser_adapt.js');
    }
  }
  public async sendTo(_config: any, { channelID, ...opts }: SendToOptions): Promise<void> {
    const { title, desc, url, imgUrl } = opts;
    const args = [title, desc, url, imgUrl];
    switch (channelID) {
      case 'wxt': {
        window.customBrowserInterface.sendToWeixinWithUrl(1, ...args);
        break;
      }
      case 'wxf': {
        window.customBrowserInterface.sendToWeixinWithUrl(2, ...args);
        break;
      }
      case 'qqf': {
        window.customBrowserInterface.sendToQQ(2, ...args);
        break;
      }
      case 'qqz': {
        window.customBrowserInterface.sendToQQ(1, ...args);
        break;
      }
    }
  }
};
